import React from 'react'
import { useTranslate } from '../TranslationText'
import NewActionButton from '../ActionButtons/NewActionButton';
import { eformApproveAndPay } from '../../common/cssclasses';

export default function ApproveAndPayLaterBtn({ isApprove = true, ...props }) {
    const { translate } = useTranslate();
    return (
        <div className={eformApproveAndPay}>
            <NewActionButton
                text={
                    <>
                        <i class="fa-solid fa-wallet"></i>
                        {isApprove ? translate("web.approveAndPayLater", "Approve And Pay Later") : translate("web.payLater", "Pay Later")}
                    </>
                }
                {...props}
            />
        </div>
    )
}
